import React, { ReactElement } from 'react';
import { Typography } from 'fronton-react';

export type QuestionType = {
	text: string;
	answer: ReactElement;
};

export const questionsDb: QuestionType[] = [
	{
		text: 'Из каких этапов состоит черновой ремонт?',
		answer: (
			<>
				<Typography variant="s" size="body_long">
					Мы всегда придерживаемся правильной и эффективной последовательности черновых
					работ.
				</Typography>
				<Typography variant="s" size="body_long">
					1. Демонтажные работы (если необходимо) <br />
					2. Возведение стен и перегородок <br />
					3. Тепло-шумоизоляция <br />
					4. Выравнивание стен и потолка <br />
					5. Стяжка пола и гидроизоляция
				</Typography>
			</>
		),
	},
	{
		text: 'Какие сроки выполнения черновых работ?',
		answer: (
			<>
				<Typography variant="s" size="body_long">
					Мы всегда стараемся сделать работы быстро, но при этом следим за качеством
					исполнения. Точные сроки обговорим с вами заранее и обязательно зафиксируем в
					договоре. 
				</Typography>
				<Typography variant="s" size="body_long">
					• Помещение до 35 м² (новостройка) — от 30 до 37 дней <br />
					• Помещение до 35 м² (вторичка) — от 32 до 39 дней <br />
					• Помещение до 52 м² (новостройка) — от 47 до 60 дней <br />• Помещение до 52 м²
					(вторичка) — от 32 до 39 дней
				</Typography>
			</>
		),
	},
];
